var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VueTagsInput',_vm._g({ref:"input",staticClass:"tags-filter",attrs:{"tags":_vm.tags,"autocomplete-min-length":0,"autocomplete-items":_vm.filteredTags,"add-only-from-autocomplete":true,"placeholder":"Account tags..."},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }